import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

const ROWS = 5

const BiddersListSkeleton: React.FC = () => {
  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <Skeleton className="h-7 w-32" />
      </div>
      <div className="py-2 flex items-center gap-2">
        <Skeleton className="h-8 w-[180px]" />
        <div className="flex-1" />
        <Skeleton className="h-8 w-32" />
        <Skeleton className="h-8 w-32" />
      </div>
      <div className="rounded-md border border-border overflow-hidden bg-card">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="!w-9 !p-0" />
              <TableHead><Skeleton className="h-3 w-16" /></TableHead>
              <TableHead><Skeleton className="h-3 w-24" /></TableHead>
              <TableHead><Skeleton className="h-3 w-14" /></TableHead>
              <TableHead><Skeleton className="h-3 w-14" /></TableHead>
              <TableHead><Skeleton className="h-3 w-12" /></TableHead>
              <TableHead><Skeleton className="h-3 w-20" /></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: ROWS }).map((_, i) => (
              <TableRow key={i}>
                <TableCell className="!w-9 !p-0 text-center">
                  <Skeleton className="h-4 w-4 mx-auto" />
                </TableCell>
                <TableCell><Skeleton className="h-4 w-36" /></TableCell>
                <TableCell><Skeleton className="h-4 w-28" /></TableCell>
                <TableCell><Skeleton className="h-4 w-40" /></TableCell>
                <TableCell><Skeleton className="h-4 w-24" /></TableCell>
                <TableCell>
                  <div className="flex gap-1">
                    <Skeleton className="h-5 w-14 rounded-full" />
                    <Skeleton className="h-5 w-12 rounded-full" />
                  </div>
                </TableCell>
                <TableCell><Skeleton className="h-4 w-8" /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <div className="flex items-center justify-end py-2 px-1">
        <Skeleton className="h-3 w-16" />
      </div>
    </div>
  )
}

export default BiddersListSkeleton
